const config = {
    build_number: '616730',
    build_timestamp: '2026-10-08T14:28:04.715Z',
    build_commit: 'cf0470493b2ee4fb43a9216e3bf1372a5ae008c9',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
